import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';
import { TranslateChildModule } from '../../helpers/translations/translate-child.module';
import { BaseTableComponent } from './base-table.component';

import { SelectionFilterTableHeaderComponent } from './components/filters/selection-filter-table-header/selection-filter-table-header.component';
import { TextFilterTableHeaderComponent } from './components/filters/text-filter-table-header/text-filter-table-header.component';
import { TextTableHeaderComponent } from './components/filters/text-table-header/text-table-header.component';
import { TableScrollTargetDirective } from './directives/table-scroll-target/table-scroll-target.directive';
import { TableFilterPipe } from './pipes/table-filter.pipe';
import { TableSortPipe } from './pipes/table-sort.pipe';

@NgModule({
    exports: [
        BaseTableComponent,
        CdkTableModule,
        SelectionFilterTableHeaderComponent,
        TextFilterTableHeaderComponent,
        TextTableHeaderComponent,
    ],
    imports: [
        CommonModule,
        CdkTableModule,
        FormsModule,
        TranslateChildModule,
        DragDropModule,
        BaseTableComponent,
        TableFilterPipe,
        TableScrollTargetDirective,
        TableSortPipe,
        SelectionFilterTableHeaderComponent,
        TextFilterTableHeaderComponent,
        TextTableHeaderComponent,
    ],
})
export class BaseTableModule {}
